import { Reducer } from "redux";

import { UpdateKeepNoteOpenResponse } from "../models/Api/Notes";
import { PutKeepNoteOpenDispatchTypes } from "../models/DispatchTypes/Notes";
import { PutKeepNoteOpenActionDispatchTypes } from "../constants/Notes";

export const initialState: UpdateKeepNoteOpenResponse = {
  loading: false,
  response: false,
};

const UpdateKeepNoteOpenReducer: Reducer<
  UpdateKeepNoteOpenResponse,
  PutKeepNoteOpenDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case PutKeepNoteOpenActionDispatchTypes.PUT_KEEP_NOTE_OPEN_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case PutKeepNoteOpenActionDispatchTypes.PUT_KEEP_NOTE_OPEN_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case PutKeepNoteOpenActionDispatchTypes.PUT_KEEP_NOTE_OPEN_RESET: {
      return initialState;
    }
  }
  return state;
};

export default UpdateKeepNoteOpenReducer;
